<template>
    <div class="box" v-title data-title="龙达简介">
        <div class="title">苏州龙达国际货运代理有限公司简介</div>
        <div class="introduce">苏州龙达国际货运代理有限公司是集木材类货运代理、船舶代理、报关、仓储、物流配送、木材加工等多种业务于一体的集团公司。企业坚持“安全、高效、友善、创新”的服务理念，竭诚为国内外木材类企业提供完善的产业链服务，致力于打造成服务于国内外经营木材企业的一流物流服务供应商；同时依托木材物流整合相关资源，全面开拓非木材物流服务。</div>
        <div class="introduce">目前，公司实现了木材物流全供应链体系，拥有ISO 9001:2015证书、AAAA综合型物流企业证书。客户遍布于美国、加拿大、新西兰、澳大利亚、俄罗斯、日本等原木和板材行业。</div>
        <el-row class="row" justify="center">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/1.png" alt="" />
                <p class="text">ISO证书</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/2.png" alt="" />
                <p class="text">AAAA物流企业</p>
            </el-col>
        </el-row>
        <div class="introduce">自有龙达华辰板材仓储区157949.2 平方，龙达大洋综合仓储区93500平方，2018年底成都区域仓投入使用，面积为21667平方，龙达通港路仓库28000平方。占地面积为164000平方的太仓港万方龙达木材产业有限公司更是集水陆集运网络区位优势于一身，为客户提供木材加工平台及疏运为一体的综合服务。</div>
        <el-row class="row" justify="center">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/3.png" alt="" />
                <p class="text">龙达华辰板材仓储区</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/4.png" alt="" />
                <p class="text">龙达大洋综合仓储区</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/5.png" alt="" />
                <p class="text">万方龙达木材产业园</p>
            </el-col>
        </el-row>
        <div class="introduce">苏州龙达立足于太仓港，积极外拓市场的，同时注重人才的培养和企业文化建设。公司设立“敬孝工资”与“急重困难周转关爱金”，解决了员工的后顾之忧，让龙达人安心积极工作，为企业创造价值的同时为客户提供更好的服务。与此同时，“龙达家”文化的弘扬，增强了员工的凝聚力。</div>
        <el-row class="row">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/6.png" alt="" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="../public/images/about/7.png" alt="" />
                <p class="text">企业文化墙</p>
            </el-col>
        </el-row>
        <div class="introduce">伴随着世界经济的发展，中国与世界各国的经济联系日益密切。苏州龙达将会借助这一契机，积极拓展业务范围，做强、做大，成为行业的标杆，为客户提供更专业、更体贴的服务。</div>
        <div class="contactFotter">公司业务部门联系方式：</div>
        <div class="contactInformation">
            <div class="contactTitle">一、 船代&散杂货事业部</div>
            <div class="text">船代：左琪 17772236010</div>
            <div class="text">散杂货：陈邦元 15962298952</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">二、集装箱事业部：</div>
            <div class="text">木材类业务：龚晓叶 15250590630</div>
            <div class="text">非木材类业务：金剑杰 17772236090</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">三、报关事业部：陈丽莉 13862386178</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">四、仓储物流事业部：</div>
            <div class="text">木材类业务：朱晓 17772236069</div>
            <div class="text">非木材类业务：吴贺  17772236025</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">五、集装箱空箱堆场：周斌  13616223598</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">六、德木供应链：姚凯13636535807</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">七、加工园区：许东平  18962622929</div>
        </div>

        <!-- 附录 -->
        <div class="appendix">
            <div class="title">附录：企业大记事</div>
            <div class="com">1.2010年4月6日 开启我们的木材物流时代</div>
            <div class="com">2.2010年5月9日 太仓码头代理的第一船</div>
            <div class="com">3.2010年5月21日 万方码头代理的第一船</div>
            <div class="com">4.2010年8月29日 代理第一批加拿大带皮原木集装箱</div>
            <div class="com">5.2010年9月29日 代理太仓港第一艘加拿大带皮原木散货船</div>
            <div class="com">6.2010年10月24日代理的第一艘加拿大板材滚装船靠泊太仓码头</div>
            <div class="com">7.2010年12月28日 代理的第一艘新西兰原木船靠泊万方码头</div>
            <div class="com">8.2011年5月7日 代理万方码头第一条加拿大板材滚装船</div>
            <div class="com">9.2011年9月&11月 代理报检和代理报关资质 ISO 企业管理认证</div>
            <div class="com">10.2012年1月 尽孝工资和急重困难周转金</div>
            <div class="com">11.2013年5月 万方龙达木材产业园</div>
            <div class="com">12.2013年9月3日 美锦码头代理的第一船</div>
            <div class="com">13.2014年初 龙达17万平的华辰物流仓储区</div>
            <div class="com">14.2014年9月 龙达大洋物流仓储区&首创40尺集装箱原木自卸车</div>
            <div class="com">15.2015年4月 开疆拓土、扩大经营，分别设立曹妃甸港宁和镇江新润船务代理有限公司</div>
            <div class="com">16.2016年4月 尝试新的业务-集装箱堆存，设立苏州众诚龙达国际集装箱储运有限公司</div>
            <div class="com">17.2016年4月 增加配送业务板块，设立苏州龙帆货运代理有限公司</div>
            <div class="com">18.2017年7月1日 代理华东地区第一条欧洲板材散货轮</div>
            <div class="com">19.2017年9月9日 代理的第一艘南美原木船靠泊美锦码头</div>
            <div class="com">20.2017年12月15日 代理的最大日本原木船靠泊万方码头</div>
            <div class="com">21.2017年10月11日 设立江苏德木电子商务有限公司</div>
            <div class="com">22.2018年12月18日 于成都建立西南区域仓</div>
            <div class="com">23.2019年12月24日 德木云链ERP系统（含PC端和APP）成功上线</div>
            <div class="com">24.2020年10月10日 设立苏州龙达国际货运代理有限公司扬州分公司</div>
            <div class="com">25.2021年3月 通过AAAA综合型物流企业评审</div>
            <div class="com">26.2021年4月入股收购苏州龙之源物流有限公司和重庆龙之捷物流有限公司</div>
            <div class="com">27.2021年6月 龙达通港路板材仓库投入使用</div>
            <div class="com">28.2022年2 月龙达华港板材库投入使用</div>
            <div class="com">29.2022年 5月龙达北三期板材仓库投入使用</div>
            <div class="com">30.2022年6月龙之源DLJ平台库投入使用</div>
        </div>
        <div class="controll">
            <div class="title">公司控股参股公司名录：</div>
            <ul>
                <li>苏州港兴国际船舶代理有限公司</li>
                <li>太仓港万方龙达木材产业有限公司</li>
                <li>苏州龙帆货运代理有限公司</li>
                <li>苏州众诚龙达国际集装箱货运代理有限公司</li>
                <li>江苏德木电子商务有限公司</li>
                <li>镇江新润船务代理有限公司</li>
                <li>唐山曹妃甸港宁船务代理有限公司</li>
                <li>苏州龙之源物流有限公司</li>
                <li>重庆龙之捷物流有限公司</li>
                <li>苏州龙达国际货运代理有限公司扬州分公司</li>
                <li>谱木（苏州）信息科技有限公司</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        
    },
    data(){
        return{
            
        }
    },
    methods:{
        
    }
}
</script>

<style scoped>
    .box{
        max-width: 120rem;
        margin: 0 auto;
        padding: 3rem 1rem;
    }
    .box>.title{
        font-size: 2.2rem;
        font-weight: bold;
        text-align: center;
        margin-bottom: 1.8rem;
    }
    .box .introduce{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .row{
        padding: 2rem 0;
    }
    .row>.el-col{
        text-align: center;
        padding: 1.5rem 0;
    }
    .el-col .img{
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    .el-col .text{
        text-align: left;
        color: #666;
        font-size: 1.4rem;
    }
    .contactFotter{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .contactInformation{
        padding-bottom: 1.5rem;
    }
    .contactInformation .contactTitle{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.4rem 0;
    }
    .contactInformation .text{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.4rem 0;
    }
    .appendix{
        margin-top: 2rem;
    }
    .appendix .title{
        line-height: 2.8rem;
        font-size: 1.6rem;
    }
    .appendix .com{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .controll{
        margin-top: 2rem;
    }
    .controll .title{
        line-height: 2.8rem;
        font-size: 1.6rem;
    }
    .controll ul li{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
</style>